






















import Stamp from '@/components/stamp-module/stamp-item.vue';
import { isTaskCompleted } from '@/store/task';
import { TaskItem } from '@/types/task';
import { TaskRequiredType } from '@tencent/wphk-act-base-cgi';
import { computed, defineComponent, PropType } from '@vue/composition-api';
import { useMultiAmountTask } from './hooks/use-multi-amount-task';
import { useMultiCountTask } from './hooks/use-multi-count-task';
import { useTaskStampCount } from './hooks/use-task-stamp-count';

export default defineComponent({
  name: 'MultiQualTaskTips',
  components: {
    Stamp,
  },
  props: {
    /** 任务信息 */
    taskInfo: {
      type: Object as PropType<TaskItem>,
      required: true,
    },
  },
  setup(prop) {
    const taskQualInfo = computed(() => {
      const targetTaskInfoDetail = prop.taskInfo.taskInfoDetail.find(item => {
        // 【预留】针对可以多次完成的任务，取第一条未完成的任务的信息展示tips；
        // 暂时不需要支持跨月和多次完成的任务，直接取第0条任务即可；
        const { requiredCount, totalCnt } = item;
        return !isTaskCompleted({ requiredCount, totalCnt });
      }) || prop.taskInfo.taskInfoDetail[0];
      const { requiredCount, totalCnt, requiredType } = targetTaskInfoDetail;
      const { status } = prop.taskInfo;
      return {
        requiredCount, totalCnt, requiredType, status,
      };
    });
    const { stampCnt } = useTaskStampCount(prop.taskInfo);
    const { isShowTips, tipsDesc } = taskQualInfo.value.requiredType === TaskRequiredType.count ?
      useMultiCountTask(taskQualInfo.value) : useMultiAmountTask(taskQualInfo.value);
    return { isShowTips, tipsDesc, stampCnt };
  },
});

